<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" >

            <el-form-item label="应用名称" prop="name" :error="formErrorMsg.name" class="fb-form-item">
                <el-input v-model="formData.name" readonly></el-input>
            </el-form-item>

            <el-form-item label="应用标识" prop="flag" :error="formErrorMsg.flag" class="fb-form-item">
                <el-input v-model="formData.flag" readonly></el-input>
            </el-form-item>


            <el-form-item label="应用配置" prop="settingTpl" :error="formErrorMsg.setting">
                <diy-form v-model="formData.setting" type="table" ></diy-form>
            </el-form-item>



            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>
    import ModuleCascader from "../../components/ModuleCascader";
    import DiyForm from "../../components/DiyForm";
    import _ from "lodash";

    export default {
        name: "RuleEdit",
        components: {DiyForm, ModuleCascader},
        data() {
            return {
                api:{
                    updateSetting:this.$api.app.updateSetting,
                   detail:this.$api.app.detail,
                },
                logoUrl:'',
                formErrorMsg:{
                    name: '',
                    flag: '',
                    logoFile: '',
                    company: '',
                    settingTpl: '',
                    setting: '',
                },
                formData: {
                    code:'',
                    name: '',
                    flag: '',
                    logoFile: '',
                    logo: '',
                    company: '',
                    settingTpl: '',
                    setting: '',

                },
                rules: {
                    name: [
                        {required: true, message: '请输入应用名称', trigger: 'blur'},
                    ],
                    flag: [
                        {required: true, message: '请输入应用标识', trigger: 'blur'},
                    ]

                }
            }
        },
        watch:{
            'formData.logo':{
                deep:true,
                handler:function () {
                    if(this.formData.logo) this.logoUrl = (this.$api.commonFile.download + '?code=' + this.formData.logo);
                }
            },
        },
        methods: {
            handlePhotoChange(e){
                let vm = this;
                this.formData.logoFile = this.$refs['appLogoFile'].files[0];
                if(this.formData.logoFile){
                    let reader = new FileReader();
                    reader.readAsDataURL(this.formData.logoFile);
                    reader.onloadend = function (e) {
                        vm.logoUrl = e.target.result;
                    };

                }
            },
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {

                        let formData = new FormData();

                        for(let key in this.formData){



                            if(key === 'setting'){
                                if(this.formData[key]) formData.append(key, JSON.stringify(this.formData[key]));
                            }else{
                                if(this.formData[key]) formData.append(key, this.formData[key]);
                            }

                        }


                        vm.$http.post(vm.api.updateSetting,formData,{headers: { "Content-Type": "multipart/form-data" }}).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){
                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(() => {
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                });
                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },

        created() {

            let vm = this;
            this.$http.post(this.api.detail,this.$qs.stringify(this.$route.query)).then(function (resp) {
                for(let key in resp.data.data){
                    for(let fKey in vm.formData){

                        if(fKey === 'setting'){
                            try {
                                vm.formData['setting'] = JSON.parse(resp.data.data[key][fKey]);
                            }catch (e) {

                            }
                        }else if(fKey === 'settingTpl'){
                            vm.formData['settingTpl'] = JSON.parse(resp.data.data[key][fKey]);
                        }else{
                            vm.formData[fKey] = resp.data.data[key][fKey]
                        }

                    }
                }

                try {
                    vm.formData['setting'] = _.defaults( vm.formData['settingTpl'],vm.formData['setting']);
                }catch (e) {
                    vm.formData['setting'] = JSON.parse(JSON.stringify( vm.formData['settingTpl']));
                }

            });

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }

</style>